export const ADDRESS_REGEX =
  /^(?:(\d+[A-Z]?|\d+\/\d+|\d+\/\d+-\d+|\d+-\d+|unit \d+\/\d+|unit \d+|flat \d+\/\d+|flat \d+|suite \d+)\s\w+|\bPO Box \d+|\bRMB \d+|Lot \d+, DP \d+|Unit \d+,?\s?.*|Suite \d+,?\s?.*)/i

export const SUBPREMISE_PREFIX_REGEX = /^(Unit|Suite|Flat)\s+/i

export const PO_BOXES_PREFIX_REGEX = /^PO Box\s+/i
export const PO_BOXES_NUMBER_REGEX = /PO Box (\d+)/i
